import { render, staticRenderFns } from "./NotificationTable.vue?vue&type=template&id=95bedc64&scoped=true"
import script from "./NotificationTable.vue?vue&type=script&lang=js"
export * from "./NotificationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95bedc64",
  null
  
)

export default component.exports